import React, { useRef } from 'react';
import './EventsListingCard.css'
import offerPopImage from "./image/offer-pops-image.svg"
import { IoShareSocialOutline } from "react-icons/io5";
import { FaRegBookmark } from "react-icons/fa";

import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaRupeeSign, FaStar, FaDoorOpen } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { add } from 'date-fns';

const EventsListingCard = ({
    title,
    date,
    clubName,
    areaName,
    time,
    rating,
    location,
    distance,
    type,
    price,
    image,
    offer,
    eventid,
    clubid,
    isEventThankyou,
    distancetotal
}) => {



 

 


    return (
        <div className="event-card-container" >
            <div className="event-card-image-wrapper">
                <div className="event-card-image-overlay-bg"></div>
                <img
                    src={image}
                    alt="Percussion Night"
                    className="event-card-image"
                />
                {offer && (
                    <img className='offer-pop' src={offerPopImage} alt="offer-pop-image" />
                )}

                {isEventThankyou && (
                    <>
                        <div className='event-card-image-overlay-event-thankyou-tag'>
                            <p>My Choice</p>
                        </div>
                    </>
                )}
                <div className="event-card-actions">
                    <span className="event-card-action-btn"><FaRegBookmark /></span>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            // downloadAndShare();
                        }}
                        className="event-card-action-btn"
                    >
                        <IoShareSocialOutline />
                    </span>
                </div>
                {offer && (
                    <div className="event-card-image-offer-overlay">
                        <div className="event-card-image-offer-box">
                            <p>{offer}</p>
                        </div>
                    </div>
                )}

            </div>
            <div className="event-card-details">
                <h3 className="event-card-title">
                    {title?.length > 25 ? title?.slice(0, 25) + '...' : title}
                </h3>
                <div className="event-card-meta">
                    <div className='event-card-time-date'>
                        <span>
                            <FaCalendarAlt /> {date}
                        </span>
                        <span>
                            <FaClock /> {time}
                        </span>
                    </div>
                    <div className='event-card-rating'>
                        <span>
                            <FaStar /> {rating}
                        </span>
                    </div>
                </div>
                <div className="event-card-location">
                    <span>
                        <FaMapMarkerAlt /> {location}
                    </span>
                    <span className="event-card-distance">{distancetotal?.toFixed(0)} kms</span>
                </div>
                <div className="event-card-extra">
                    <div className='event-card-type-price'>
                        <span>
                            <FaDoorOpen /> {type}
                        </span>
                        <span>
                            {price > 0 && <FaRupeeSign />} {price > 0 && price}
                        </span>
                    </div>

                    {!isEventThankyou && (
                        <Link to={`/event-book/${clubid}/${eventid}`} style={{ textDecoration: "none" }}>
                            <div className='event-card-button'>
                                <button>Book Now</button>
                            </div>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EventsListingCard;

